module.exports = __webpack_public_path__ + "img/press.2a3a8b59.png";